
(() => {
  const main = document.getElementById('productMainImage');
  const price = document.getElementById('productPrice');
  document.querySelectorAll('.product-thumb').forEach(btn => btn.addEventListener('click', () => {
    document.querySelectorAll('.product-thumb').forEach(x => x.classList.remove('active'));
    btn.classList.add('active');
    main.src = btn.dataset.src;
  }));
  document.querySelectorAll('.product-option').forEach(btn => btn.addEventListener('click', () => {
    document.querySelectorAll('.product-option').forEach(x => x.classList.remove('active'));
    btn.classList.add('active');
    price.textContent = btn.dataset.price;
  }));
  const stage = document.getElementById('productStage');
  let raf = 0;
  stage.addEventListener('mousemove', e => {
    const r = stage.getBoundingClientRect();
    const x = Math.max(0, Math.min(r.width, e.clientX-r.left));
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      stage.style.setProperty('--scan-x', `${x}px`);
      stage.style.setProperty('--scan-ratio', x/r.width);
    });
  });
})();
